import MembersIcon from '@sats-group/icons/24/members';
import TicketIcon from '@sats-group/icons/24/ticket';
import TimeIcon from '@sats-group/icons/24/time';
import Expander from '@sats-group/ui-lib/react/expander/expander';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ContentContainer from '~/client/components/content-container/content-container';
import DisplayBootCampEvents from '~/client/components/display-boot-camp-events/display-boot-camp-events';
import DropdownWrapper from '~/client/components/dropdown-wrapper/dropdown-wrapper';
import ElementInterpolator from '~/client/components/element-interpolator/element-interpolator';
import Layout from '~/client/components/layout/layout';
import PageHeader from '~/client/components/page-header/page-header';
import RichText from '~/client/components/rich-text/rich-text';
import type { BootCampConceptPage as Props } from './boot-camp-concept-page.types';

const BootCampConceptPage: React.FunctionComponent<Props> = ({
  about,
  details,
  dropdownWrapper,
  events,
  faqs,
  header,
  layout,
  results,
  totalBootCampEvents,
}) => (
  <Layout {...layout}>
    <div className="boot-camp-concept-page">
      <div className="boot-camp-concept-page__header">
        <PageHeader {...header} />
      </div>
      <ContentContainer
        className="boot-camp-concept-page__content"
        theme={ContentContainer.themes.wide}
      >
        <div className="boot-camp-concept-page__about">
          <Text
            elementName="h3"
            theme={Text.themes.emphasis}
            size={Text.sizes.headline3}
          >
            {about.title}
          </Text>
          <Text>{about.description}</Text>
        </div>
        <div className="boot-camp-concept-page__details">
          <Text
            className="boot-camp-concept-page__events-header"
            elementName="h3"
            size={Text.sizes.headline3}
            theme={Text.themes.emphasis}
          >
            {details.heading}
          </Text>
          <div className="boot-camp-concept-page__details-item-wrapper">
            {details.sessions ? (
              <div className="boot-camp-concept-page__details-item">
                <TimeIcon />
                <Text className="boot-camp-concept-page__details-session">
                  {details.sessions}
                </Text>
              </div>
            ) : null}
            <div className="boot-camp-concept-page__details-item">
              <MembersIcon />
              <Text>{details.participants}</Text>
            </div>
            <div className="boot-camp-concept-page__details-item">
              <TicketIcon /> <Text>{details.price}</Text>
            </div>
          </div>
          <Text
            className="boot-camp-concept-page__details-sub-text"
            size={Text.sizes.small}
          >
            {details.subText}
          </Text>
        </div>
      </ContentContainer>

      <div className="boot-camp-concept-page__dropdown-wrapper" id={events.id}>
        <ContentContainer
          theme={ContentContainer.themes.wide}
          className="boot-camp-concept-page__dropdown-inner"
        >
          <Text
            elementName="h2"
            size={Text.sizes.headline2}
            theme={Text.themes.emphasis}
          >
            {events.title}
          </Text>
          {events.content.events.length ? (
            <>
              <DropdownWrapper {...dropdownWrapper} />
              <Text size={Text.sizes.small}>
                <ElementInterpolator
                  template={results}
                  elements={{
                    number: (
                      <Text elementName="span" theme={Text.themes.emphasis}>
                        {totalBootCampEvents}
                      </Text>
                    ),
                  }}
                />
              </Text>
            </>
          ) : null}
        </ContentContainer>
        <ContentContainer
          theme={ContentContainer.themes.wide}
          className="boot-camp-concept-page__events"
        >
          <DisplayBootCampEvents {...events.content} />
        </ContentContainer>
      </div>
      {faqs ? (
        <ContentContainer
          theme={ContentContainer.themes.wide}
          className="boot-camp-concept-page__faq-container"
        >
          {faqs.map((faq, index) => (
            <Expander key={index} {...faq} itemRenderer={RichText} />
          ))}
        </ContentContainer>
      ) : null}
    </div>
  </Layout>
);

export default BootCampConceptPage;
